import React from "react";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../Shared/Styles/ModalStyles";

import Divider from "@material-ui/core/Divider";

import TextField from "@material-ui/core/TextField";
//import BrokerInviteEmployerAsyncSelect from "./BrokerInviteEmployerAsyncSelect";
import api from "../../Shared/Functions/APIHelpers";

class ViewEmployersDialog extends React.Component {
  state = {
    employers: [],
  };
  componentDidMount() {}

  getPermissionLevel = (permissionLevel) => {
    if (permissionLevel === 0) return "Notify";
    if (permissionLevel === 1) return "View";
    if (permissionLevel === 2) return "Update";
    return "";
  };
  close = () => {
    this.setState({ email: "" }, () => {
      this.props.Close();
    });
  };

  handleClose = () => {
    this.close();
  };

  render() {
    const { fullScreen, Broker } = this.props;
    return (
      <div>
        <Dialog
          open={!!this.props.Open}
          aria-labelledby="form-dialog-title"
          disableBackdropClick={true}
          fullScreen={fullScreen}
          scroll="paper"
        >
          <DialogTitle id="form-dialog-title">
            {Broker.first_name} {Broker.last_name}'s Employers
            <br />
            <Typography variant="body1">{Broker.email}</Typography>
          </DialogTitle>

          <DialogContent
            style={{ minHeight: 400, minWidth: 325, maxWidth: 450 }}
          >
            <Typography variant="body1">
              This individual has access to the following employers.
            </Typography>
            <div style={{ marginTop: 30 }}>
              {Broker.employers.map((employer, index) => {
                return (
                  <div key={index} style={{ display: "block" }}>
                    <div>
                      <Typography variant="h6">{employer.name}</Typography>
                    </div>
                    <div>
                      <Typography variant="body2">
                        Permission Level{": "}
                        {this.getPermissionLevel(employer.permission_level)}
                      </Typography>
                      <Typography variant="body2">
                        Set by employer: {employer.relationship_level === 1 ? "Yes" : "No"} {" "}
                    </Typography>                       
                    </div>
                    <Divider style={{marginTop:20, marginBottom:20}}/>
                  </div>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <div style={{ width: "100%" }}>
              <div style={{ float: "left" }}></div>
              <div style={{ float: "right" }}>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </div>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(ViewEmployersDialog));
